/* src/app/components/state-label/state-label.component.scss */
.state-container {
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}
/*# sourceMappingURL=state-label.component.css.map */
